const initialState = {
    name:"",
    timestamps:[],
    method:{
        type:"daily",
        view:"list"
    }
}

export const Item = (state = [], action) => {
    switch (action.type) {
        case 'FETCH_ITEM':
            return state = {
                ...initialState,
                ...action.payload
            };
        case 'RESET':
            return state = {
                ...initialState,
                ...action.payload
            };
        case 'SET_METHOD':
            return state = { 
                ...initialState,
                ...action.payload
             };
        default:
            return initialState;
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/item.js